import React, { useState } from 'react';

const faqData = [
  {
    question: 'How do I book a waxing appointment?',
    answer: 'You can easily book through our website or mobile app by selecting your preferred date and time. Our professionals will come directly to your home.'
  },
  {
    question: 'Is waxing safe to do at home?',
    answer: 'Absolutely! Our trained estheticians follow strict hygiene protocols and use professional-grade products to ensure your safety and comfort.'
  },
  {
    question: 'How long does a waxing session take?',
    answer: 'Depending on the service, sessions typically last between 20 minutes to 1 hour. We’ll give you an estimated time when you book.'
  },
  {
    question: 'How should I prepare for my waxing appointment?',
    answer: 'Make sure your hair is at least ¼ inch long for effective waxing. Avoid applying lotions or oils before the session, and wear comfortable clothing.'
  },
  {
    question: 'Does waxing hurt?',
    answer: 'Waxing might cause some discomfort, especially the first time, but our experts use techniques to minimize pain. Many clients find it easier with each session.'
  },
  {
    question: 'What areas can I get waxed at home?',
    answer: 'We offer a full range of waxing services including face, arms, legs, bikini, back, and more — all in the comfort of your home.'
  },
  {
    question: 'How often should I get waxed?',
    answer: 'For best results, schedule waxing every 3-6 weeks depending on your hair growth and skin sensitivity.'
  },
  {
    question: 'What if I have sensitive skin or allergies?',
    answer: 'Let us know in advance. We have gentle products and formulas designed for sensitive skin to ensure a safe experience.'
  },
  {
    question: 'Are your waxing products safe and hygienic?',
    answer: 'Yes, we use high-quality, skin-friendly waxing products and follow strict sanitation protocols to maintain hygiene.'
  },
  {
    question: 'What if I need to reschedule or cancel?',
    answer: 'You can reschedule or cancel up to 24 hours before your appointment without any charges.'
  },
  {
    question: 'Do you offer packages or discounts?',
    answer: 'Yes, we have special packages for regular clients and seasonal discounts. Check our website or contact us for details.'
  },
  {
    question: 'What if I have never waxed before?',
    answer: 'No worries! Our professionals will guide you through the process to ensure you feel comfortable and informed.'
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="section">
      <div className="container">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-container">
          {faqData.map((item, index) => (
            <div className={`faq-item ${activeIndex === index ? 'active' : ''}`}
              key={item.question}
            >
              <div className="faq-question" onClick={() => toggle(index)}>
                {item.question}
              </div>
              <p className="faq-answer">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;